import type { CoverLetterData } from "@/lib/coverLetterEditor/types";

// Mirrors resumeEditor/storage.ts exactly, with a distinct key prefix —
// cover letter drafts are a separate collection from resume drafts.
const PREFIX = "nohaya-cover-letter:";
const INDEX_KEY = "nohaya-cover-letter-index";

export function saveCoverLetter(data: CoverLetterData): void {
  if (typeof window === "undefined") return;
  const updated: CoverLetterData = {
    ...data,
    meta: { ...data.meta, updatedAt: new Date().toISOString() },
  };
  window.localStorage.setItem(PREFIX + data.id, JSON.stringify(updated));
  const index = listCoverLetterIds();
  if (!index.includes(data.id)) {
    window.localStorage.setItem(INDEX_KEY, JSON.stringify([...index, data.id]));
  }
}

export function loadCoverLetter(id: string): CoverLetterData | null {
  if (typeof window === "undefined") return null;
  const raw = window.localStorage.getItem(PREFIX + id);
  if (!raw) return null;
  try {
    return JSON.parse(raw) as CoverLetterData;
  } catch {
    return null;
  }
}

export function listCoverLetterIds(): string[] {
  if (typeof window === "undefined") return [];
  try {
    const raw = window.localStorage.getItem(INDEX_KEY);
    return raw ? (JSON.parse(raw) as string[]) : [];
  } catch {
    return [];
  }
}
